import clsx from "clsx";
import { DarwinAppBar, NavLinkButton } from "./Header.style";

import React, { useState, useContext, useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import { Drawer, Box } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Link from "@material-ui/core/Link";
import { observer, useObserver } from "mobx-react-lite";
import { StoresContext, Stores } from "Globals/Stores";
import Cog from "Content/Cog.svg";
import { useMediaQuery } from "@shoothill/core";
import { AppUrls } from "AppUrls";
import { Grid, Else, Show } from "@shoothill/core";
import { defaultTheme } from "Globals/Styles/AppTheme";
import { ReactComponent as Logo } from "../../Content/dg_logo_full_cmyk_primary.svg";
import { ApprovalCounter } from "Views/Approval/Navigation/ApprovalCounter";
import { HeaderViewModel } from "./HeaderViewModel";
import { ApprovalSignalRViewModel } from "Views/Approval/ApprovalSignalR/ApprovalSignalRViewModel";
interface LinkButtonProps {
    className?: string;
    linkText?: string;
    img?: any;
    imgDesc?: string;
    imgClass?: string;
    to?: any;
    onClick?: any;
}

export const LinkButton: React.FC<LinkButtonProps> = (props) => {
    let component: any = RouterLink;
    if (!props.to) {
        component = Box; // Defaults to Box if no link provided
    }

    return (
        <NavLinkButton className={props.className} color="inherit">
            <Link color={"inherit"} component={component} to={props.to} onClick={props.onClick} underline="none" style={{ display: "flex", flexDirection: "row" }}>
                {props.linkText && (
                    <Typography color={"inherit"} variant={"button"}>
                        {props.linkText}
                    </Typography>
                )}
                {props.img && <img src={props.img} alt={props.imgDesc} className={props.imgClass} />}
                {props.children}
            </Link>
        </NavLinkButton>
    );
};

export const Header: React.FC = observer(() => {
    const location = useLocation();
    const viewModel = HeaderViewModel.Instance;

    useEffect(() => {
        // Cleanup when component unmounts
        return () => {
            //viewModel.cleanUp();
        };
    }, []);

    const getClassName = (root: string) => {
        return clsx({
            ["header-item"]: true,
            ["active"]: location.pathname.startsWith(root),
        });
    };

    const [open, setOpen] = useState(false);
    const storesContext = useContext<Stores>(StoresContext);
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;

    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);

    const loggedInList = (
        <>
            {!storesContext.Domain.AccountStore.isSiteManager && (
                <LinkButton className={getClassName("/approval")} linkText="Approvals" to={AppUrls.Client.Approval.List}>
                    {ApprovalSignalRViewModel.Instance.getTotalCount !== 0 ? <ApprovalCounter count={ApprovalSignalRViewModel.Instance.getTotalCount} /> : null}
                </LinkButton>
            )}

            <LinkButton className={getClassName("/central")} linkText={"Central"} to={AppUrls.Client.Central.View} />
            <LinkButton className={getClassName("/project")} linkText={"Projects"} to={AppUrls.Client.Project.List} />
            {!storesContext.Domain.AccountStore.isSiteManager && <LinkButton className={getClassName("/po")} linkText={"Purchase Orders"} to={AppUrls.Client.PurchaseOrder.List} />}
            {!storesContext.Domain.AccountStore.isSiteManager && <LinkButton className={getClassName("/supplier")} linkText={"Suppliers"} to={AppUrls.Client.Supplier.List} />}
            {storesContext.Domain.AccountStore.getCanViewStock && <LinkButton className={getClassName("/stock")} linkText={"Stock"} to={AppUrls.Client.Stock.List} />}
            {!storesContext.Domain.AccountStore.isSiteManager && <LinkButton className={getClassName("/invoice")} linkText={"Invoicing"} to={AppUrls.Client.Invoicing.List} />}
            {!storesContext.Domain.AccountStore.isSiteManager && <LinkButton className={getClassName("/report")} linkText={"Reports"} to={AppUrls.Client.Report.AllProject} />}
            {/* For testing */}
            {/* {!storesContext.Domain.AccountStore.isSiteManager && <LinkButton linkText={"InductionLanding"} to={AppUrls.Client.Induction.Landing} />} */}
            {/* For testing */}
            {/* {!storesContext.Domain.AccountStore.isSiteManager && (
                <LinkButton linkText={"Signin/out"} to={AppUrls.Client.Induction.Access.Landing.replace(":projectId", "a2947544-f89e-4a31-987d-46343316a482")} />
            )} */}
            {storesContext.Domain.AccountStore.getCanViewInductions && (
                <LinkButton className={getClassName("/induction")} linkText={"Inductions"} to={AppUrls.Client.Induction.List} />
            )}
            <LinkButton linkText={"Logout"} onClick={() => storesContext.Domain.AccountStore.Logout(true)} />
        </>
    );

    const adminList = (
        <>
            {storesContext.Domain.AccountStore.getCanViewSettings && (
                <LinkButton className={getClassName("/admin")} img={Cog} imgClass="admin-cog" imgDesc="Admin" to={AppUrls.Client.Admin.User.List} />
            )}
            <LinkButton linkText={"Logout"} onClick={() => storesContext.Domain.AccountStore.Logout(true)} />
        </>
    );

    const loggedOutList = (
        <>
            {/*<LinkButton linkText={"Login"} to={AppUrls.Client.Account.Login} />
            <LinkButton linkText={"Examples"} to={AppUrls.Client.Samples} />
            <LinkButton linkText={"Register"} to={AppUrls.Client.Account.Register} />
            <LinkButton linkText={"Test Page"} to={AppUrls.Client.Test} /> */}
        </>
    );

    return (
        <>
            {/* Root */}
            <DarwinAppBar position={"sticky"} style={{ color: defaultTheme.palette.common.black }}>
                {/* Content */}
                <Toolbar>
                    {!isMobile && (
                        <>
                            {/* Navigate to Home */}
                            <Box flexGrow={1} style={{ cursor: "pointer" }}>
                                {/* <img
                                    src={darwinLogo}
                                    alt="Darwin Group"
                                    className="logoDarwin"
                                    onClick={() => getHistory().push(StoresInstance.Domain.AccountStore.getDefaultRoute())}
                                /> */}

                                <Logo />
                                {storesContext.Domain.AccountStore.getCanShowAccountName && (
                                    <>
                                        <span
                                            className="font-openSans"
                                            style={{ display: "inline-block", marginLeft: "30px", fontWeight: "700", fontSize: "12px", textTransform: "unset", color: "#000" }}
                                        >
                                            {storesContext.Domain.AccountStore.DisplayName}
                                        </span>
                                    </>
                                )}
                            </Box>
                            <Show
                                if={
                                    storesContext.Domain.AccountStore.IsLoggedIn &&
                                    !storesContext.Domain.AccountStore.isSiteTablet &&
                                    !storesContext.Domain.AccountStore.isInductionUser
                                }
                            >
                                <Box>
                                    {/* Navigation Options */}
                                    {storesContext.Domain.AccountStore.isAdminRole ? adminList : loggedInList}
                                </Box>
                                <Else>
                                    <Box>
                                        {/* Navigation Options */}
                                        {loggedOutList}
                                    </Box>
                                </Else>
                            </Show>
                        </>
                    )}
                    {isMobile && !storesContext.Domain.AccountStore.isSiteTablet && !storesContext.Domain.AccountStore.isInductionUser && (
                        <>
                            <IconButton color="inherit" aria-label="Open drawer" onClick={handleDrawerOpen} edge="start">
                                <MenuIcon />
                            </IconButton>
                        </>
                    )}
                </Toolbar>
            </DarwinAppBar>
            <Drawer variant="persistent" anchor="left" open={open && isMobile}>
                <div>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                {ApprovalSignalRViewModel.Instance.getTotalCount !== 0 ? <ApprovalCounter count={ApprovalSignalRViewModel.Instance.getTotalCount} /> : null}
                <Show if={storesContext.Domain.AccountStore.IsLoggedIn}>
                    <Grid justifyItems={"flex-start"}>{loggedInList}</Grid>
                    <Else>
                        <Grid justifyItems={"flex-start"}>{loggedOutList}</Grid>
                    </Else>
                </Show>
            </Drawer>
        </>
    );
});
